import { ReactNode } from "react";
import { useHistory } from "react-router-dom";
import { Card } from "react-bootstrap";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { Heading } from "components/Heading";
import { Container } from "components/Layout/Container";
import { usePageTopAndBottomRows } from "components/utils/page";
import { PageComponentsList } from ".";
import { HeadingLevel } from "../../types/HeadingLevel";
import { Icon } from "../Icon";
import { Button } from "../Button";

export function SuccessCardPage({ icon, title, text, buttonText, to }: SuccessCardPageProps) {
    const history = useHistory();
    const { topRows, bottomRows } = usePageTopAndBottomRows();

    return (
        <>
            <PageComponentsList components={topRows} />
            <Container style={{ maxWidth: 480 }} className="mt-6 mb-6">
                <Card className="p-2 rounded-top-4 rounded-bottom-4 border-0 shadow-sm">
                    <Card.Body className="d-flex flex-column align-items-center">
                        <Icon icon={["far", icon]} className="fs-1 text-secondary" />
                        <Heading level={HeadingLevel.H5} className="fw-medium m-0 mt-2">
                            {title}
                        </Heading>
                        {text && <p className="text-secondary text-center mt-1">{text}</p>}
                        {buttonText && to && (
                            <Button variant="primary" onClick={() => history.push(to)}>
                                {buttonText}
                            </Button>
                        )}
                    </Card.Body>
                </Card>
            </Container>
            <PageComponentsList components={bottomRows} />
        </>
    );
}

interface SuccessCardPageProps {
    icon: IconName;
    title: string;
    text?: ReactNode;
    buttonText?: string;
    to?: string;
}
